import $ from 'jquery';
import transitionEnd from './transitionend';
import imageLoader from './imageLoader.js';

const isTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;

export default function() {
    const $mustheads = document.querySelectorAll('.main-slider');

    $mustheads.forEach(($musthead) => {
        const images = [];

        $musthead.querySelectorAll('.main-slider__item').forEach((item, i) => {
            const $bg = item.querySelector('.main-slider__item__bg');
            if($bg) {
                const pictureSrc = $bg.getAttribute('data-picture');
                images.push({'bgElement': $bg, 'src': pictureSrc, 'isFirst': i === 0});
            }
        });

        return images.reduce((promiseChain, image) => {
            return promiseChain.then(chainResults => {
                return new Promise(function(resolve, reject) {
                    imageLoader(image.src)
                        .then((src) => {
                            if(image.isFirst) {
                                const $clone = image.bgElement.cloneNode();
                                $clone.style.backgroundImage = `url(${src})`;

                                $clone.classList.add('main-slider__item__bg--animated');

                                $clone.addEventListener(transitionEnd, function() {
                                    image.bgElement.parentNode.removeChild(image.bgElement);
                                    resolve(src);
                                });

                                image.bgElement.parentNode.insertBefore($clone, image.bgElement.nextSibling);

                                setTimeout(() => {
                                    $clone.classList.remove('main-slider__item__bg--animated');
                                }, 100);
                            }
                            else {
                                image.bgElement.style.backgroundImage = `url(${src})`;
                                resolve(src);
                            }
                        })
                        .catch(() => {
                            reject();
                        });
                });
            });
        }, Promise.resolve([])).then(arrayOfResults => {
            $musthead.classList.remove('masthead--unload');

            $($musthead).find('.main-slider__items-wrapper').slick({
                adaptiveHeight: true,
                autoplay: true,
                autoplaySpeed: 350000,
                arrows: true,
                prevArrow: '<button class="slick-arrow slick-prev" type="button"><svg><use xlink:href="#arrow_icon" x="0" y="0" /></svg></button>',
                nextArrow: '<button class="slick-arrow slick-next" type="button"><svg><use xlink:href="#arrow_icon" x="0" y="0" /></svg></button>',
                appendDots: $($musthead).find('.wrapper'),
                dots: true,
                dotsClass: 'main-slider__paginator',
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 1000,
                fade: !isTouch
            });
        });
    })
}
